import axiosClient from '@/api/apiClient';
import getSocketIdRequestTransformer from '@/api/requestTransformers/socketId.transformer';
import { AxiosResponse } from 'axios';

export default {
  getSocketEventsByLastSocketEventId(lastSocketEventId: number, placeId: string): Promise<any[]> {
    return axiosClient.get(
      `/widget/event-log/list/${placeId}/${lastSocketEventId}`,
      {
        transformRequest: getSocketIdRequestTransformer,
      },
    )
      .then(({ data }: AxiosResponse<any[]>) => data);
  },
  getLastSocketEventId(placeId: string): Promise<number | null> {
    return axiosClient.get(
      `/widget/event-log/log/last/${placeId}`,
      {
        transformRequest: getSocketIdRequestTransformer,
      },
    )
      .then(({ data }: AxiosResponse<number | null>): number | null => data);
  },
};
